export default "__VITE_ASSET__7a51a247__"